module.exports = __webpack_public_path__ + "img/img12.7773b49c.jpg";